// extracted by mini-css-extract-plugin
export default {"container":"Input_container__f+D4J","horizontal":"Input_horizontal__jWiJ2","inputLabel":"Input_inputLabel__U5WCi"};